import { Box, Typography } from "@mui/material";
import React from "react";

export interface HorizontalBarItem {
  key: string;
  label: string;
  value: number;
  color: string;
}

export interface HorizontalBarListProps {
  title: string;
  data: HorizontalBarItem[];
}

const BAR_HEIGHT = 18;

export const HorizontalBarListComponent: React.FC<HorizontalBarListProps> = ({
  title,
  data,
}) => {
  const maxValue = Math.max(...data.map((d) => d.value), 1);

  return (
    <Box
      sx={{
        backgroundColor: "#FFFDF7",
        borderRadius: "14px",
        padding: "18px 20px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        flex: "1 1 320px",
        minWidth: 0,
      }}
    >
      <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#333", mb: 2 }}>
        {title}
      </Typography>

      <Box display="flex" flexDirection="column" gap={1.5}>
        {data.map((item) => {
          const widthPct = Math.max((item.value / maxValue) * 100, item.value > 0 ? 3 : 0);
          return (
            <Box
              key={item.key}
              display="flex"
              alignItems="center"
              gap={1.5}
              tabIndex={0}
              sx={{ outline: "none" }}
            >
              <Box
                sx={{
                  width: 9,
                  height: 9,
                  borderRadius: "50%",
                  backgroundColor: item.color,
                  flexShrink: 0,
                }}
              />
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#555",
                  width: 100,
                  flexShrink: 0,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {item.label}
              </Typography>
              <Box
                sx={{
                  flex: 1,
                  height: BAR_HEIGHT,
                  backgroundColor: "#f0efec",
                  borderRadius: "4px",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    width: `${widthPct}%`,
                    height: "100%",
                    backgroundColor: item.color,
                    borderRadius: "0 4px 4px 0",
                    transition: "width 0.3s ease",
                  }}
                />
              </Box>
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: 700,
                  color: "#333",
                  width: 28,
                  textAlign: "right",
                  flexShrink: 0,
                }}
              >
                {item.value}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
